/**
    * @File 
    * @Author fanxuyang
    * @Date 2024/10/8 11:13:40
    * @FilePath src/main/router/routers/app.js
*/
import app from '../modules/app.js'

export default [
  { path: '/app/create.xhtml', name: 'create', component: app.create, meta: { title: "", single: true } },
  { path: '/app/download.xhtml', name: 'download', component: app.download, meta: { title: "", single: true } },
  { path: '/app/yunzu.xhtml', name: 'yunzu', component: app.yunzu, meta: { title: "", single: true } },
  { path: '/app/userAgreement.xhtml', name: 'userAgreement', component: app.userAgreement, meta: { title: "", single: true } },
  { path: '/app/help_v2.xhtml', name: 'help_v2', component: app.help_v2, meta: { title: "", single: true } },
  { path: '/app/file_ukey.xhtml', name: 'file_ukey', component: app.file_ukey, meta: { title: "", single: true } },
  { path: '/app/file_fee.xhtml', name: 'file_fee', component: app.file_fee, meta: { title: "", single: true } },
  { path: '/app/file_pop.xhtml', name: 'file_pop', component: app.file_pop, meta: { title: "", single: true } },
  { path: '/app/article.xhtml', name: 'article', component: app.article, meta: { title: "", single: true } },
  { path: '/app/articleApplet.xhtml', name: 'articleApplet', component: app.articleApplet, meta: { title: "", single: true } },
  { path: '/app/appdown.xhtml', name: 'appdown', component: app.appdown, meta: { title: "", single: true } },

  // 云证移动-首页
  { path: '/app/yunZhengMD.xhtml', name: 'yunZhengMD', component: app.yunZhengMD, meta: { single: true } },
  // 云证移动-融资页
  { path: '/app/yunZhengMDfinace.xhtml', name: 'yunZhengMDfinace', component: app.yunZhengMDfinace, meta: { single: true } },

  // 链信认证说明 2021-01-08
  { path: '/app/certification_instructions.xhtml', name: 'certification_instructions', component: app.certification_instructions, meta: { single: true } },
  // 云保理移动端页面
  { path: '/Lx/Lxh5.xhtml', name: 'Lxh5', component: app.Lxh5, meta: { single: true } },
  //云链H5(用户中心人脸认证结果)
  { path: '/user/Ylh5.xhtml', name: 'Ylh5', component: app.Ylh5, meta: { single: true } },
  //云租询价详情分享H5
  { path: '/app/inquiryDetail.xhtml', name: 'inquiryDetail', component: app.inquiryDetail },
  //云租询价详情分享 下载页H5
  { path: '/app/yzDownload.xhtml', name: 'yzDownload', component: app.yzDownload },

  //链信-投资方查看融资排行-融资排行页面
  { path: '/app/financingDetail.xhtml', name: 'financingDetail', component: app.financingDetail },
  //链信-投资方查看融资排行-搜索页面
  { path: '/app/financingSearch.xhtml', name: 'financingSearch', component: app.financingSearch },
  //云租-实名认证人脸认证结果
  { path: '/yz/faceAuthResults.xhtml', name: 'FaceAuthResults',component: app.faceAuthResults,meta:{single:true, title: '用户实名认证'}},
  
  // 2023.07.21 add 实名认证人脸认证结果 公共页面  提供给各业务线使用 不需再进行开发
  { path: '/faceAuthResultsCommon.xhtml', name: 'faceAuthResultsCommon',component: app.faceAuthResultsCommon,meta:{single:true, title: '人脸比对'}},

  


  //云租-融资确权人脸认证结果
  { path: '/yz/faceComparisonResults.xhtml', name: 'FaceComparisonResults',component: app.faceComparisonResults,meta:{single:true,title: '用户实名认证'}},
  
  //区块链IM专题页
  { path: '/app/blockchainSpecial', name: 'blockchainSpecial', component: app.blockchainSpecial ,meta:{title:'区块链IM'}},

  // 链信扫个人名片分享
  { path: '/Lx/personalInformation.xhtml', name: 'personalInformation', component: app.personalInformation,meta:{single:true}},
  // 链信扫群名片分享
  { path: '/Lx/groupInformation.xhtml', name: 'groupInformation', component: app.groupInformation,meta:{single:true}},


  // 消息发送-公告通知
  { path: '/Lx/sendMessageType', name: 'sendMessageType', component: app.sendMessageType,meta:{single:true}},

  // 消息发送-公告通知
  { path: '/app/inviteFriends', name: 'inviteFriends', component: app.inviteFriends,meta:{single:true, title: "企业好友邀请"}},

  //华夏银行二维码页面
  { path: '/app/hxQrcode.xhtml', name: 'hxQrcode', component: app.hxQrcode, meta: { title: "", single: true }},
  //意愿验证h5
  { path: '/app/intentionVerify.xhtml', name: 'intentionVerify', component: app.intentionVerify, meta: { title: "", single: true }},
  //意愿验证结果页
  { path: '/app/verifyResult.xhtml', name: 'verifyResult', component: app.verifyResult, meta: { title: "", single: true }},


]
